import { getUniversalUrl, URL_TYPE } from '../../get-universal-url';

type LogoColorScheme = 'light' | 'dark';

export function getBrandLogo(logoColorScheme: LogoColorScheme) {
  return getUniversalUrl(`/images/logo-${logoColorScheme}.svg`, URL_TYPE.PUBLIC);
}
